import { GLCode } from '@rygen/rygen-ui/model';
import { alphabeticComparator, ComparatorResult } from '@rygen/rygen-ui/util';

const sortByName = alphabeticComparator({ isCaseSensitive: false });

export const glCodeComparator = (a: GLCode, b: GLCode): ComparatorResult => {
  if (a.autoGLCode) {
    return -1;
  } else if (b.autoGLCode) {
    return 1;
  } else {
    return sortByName(a.code, b.code) as ComparatorResult;
  }
};
